'use strict';

module.exports = {
    notifyMeSubscribed: function () {
        $('body').on('click', '.js-notify-me', function (e) {
            e.preventDefault();
            const $this = $(this);
            var ele = $(this);
            var url = ele.data('notifyme-url');
            if (!url) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    if (data.success) {
                        const notifyMeDiv = $('<div></div>').addClass('label-notify-me').html(data.message);
                        $this.closest('.notifyme-container').empty().append(notifyMeDiv);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    if (!err.responseJSON.loggedin && err.responseJSON.loginUrl) {
                        $('body').trigger('signinModal:open', err.responseJSON.loginUrl);
                        if($this.closest('.product-quickview').length) {
                            $('#quickViewModal .close').trigger('click');
                        }
                    }
                    $.spinner().stop();
                }
            });
        });
    }

};
